//通用
import $http from '@/plugins/http.js'
import $download from '@/plugins/download.js'

//通用下载请求
export function download(params){
    return $http.Downloadget('/api/common/download',params)
}

//通用下载请求
export function downloadNew(params){
    return $download.Downloadget('/api/common/download',params)
}
//我的收藏 新增
export function ttCollectionAdd(params){
    return $http.post('/collection/ttCollection',params)
}
//我的收藏 查询列表
export function ttCollectionList(params){
    return $http.get('/collection/ttCollection',params)
}
//我的收藏 详情
export function ttCollectionContent(params){
    return $http.get('/collection/ttCollection/'+params)
}
//我的收藏 取消收藏
export function ttCollectiondel(params){
    return $http.del('/collection/ttCollection/'+params)
}
//内容页取消收藏
export function deleteByMessageId(params){
    return $http.del('/collection/ttCollection/deleteByMessageId/'+params)
}
